import { Union, Record } from "../../../fable_modules/fable-library.3.7.12/Types.js";
import { ScreenshotListItemViewModel, ScreenshotListItemViewModel$reflection } from "../../../Optiscan.Models/View/ScreenshotInfoViewModel.js";
import { union_type, class_type, int32_type, bool_type, string_type, float64_type, record_type, list_type } from "../../../fable_modules/fable-library.3.7.12/Reflection.js";
import { AsyncResultComputationExpression_asyncResult, AsyncResultComputationExpression_AsyncResultBuilder__Return_1505, AsyncResult_mapError, AsyncResultComputationExpression_AsyncResultBuilder__Bind_454FBA93, AsyncResultComputationExpression_AsyncResultBuilder__Delay_Z5276B41B } from "../../../fable_modules/AsyncResult.0.3.0/Result.fs.js";
import { ErrorMessage } from "../../../Optiscan.Models/ErrorMessage.js";
import { ofPromise } from "../../../Common/Extensions.js";
import { tail, head, isEmpty, cons, length, contains, filter, toArray, empty, ofArray, map } from "../../../fable_modules/fable-library.3.7.12/List.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.3.1.3/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.3.1.3/PromiseImpl.fs.js";
import { S3_PutObjectRequestParams, S3_PutObjectRequestParams_get_create } from "../../../bindings/Aws/Fable.Helpers.Aws.js";
import { map as map_1, defaultArg, some } from "../../../fable_modules/fable-library.3.7.12/Option.js";
import { fetch$ } from "../../../fable_modules/Fable.Fetch.2.4.0/Fetch.fs.js";
import { Array_groupBy } from "../../../fable_modules/fable-library.3.7.12/Seq2.js";
import { comparePrimitives, uncurry, numberHash, structuralHash, stringHash } from "../../../fable_modules/fable-library.3.7.12/Util.js";
import { Pdf_Images_Basic_ptToMm, Pdf_Spacing_baseSpacingY, Pdf_Spacing_leftMargin, Pdf_Spacing_topMargin } from "../PatientReportHelpers.js";
import { sortBy, tryHead, fold, tryFind } from "../../../fable_modules/fable-library.3.7.12/Array.js";
import { toList } from "../../../fable_modules/fable-library.3.7.12/Seq.js";
import { rangeDouble } from "../../../fable_modules/fable-library.3.7.12/Range.js";

export class Args extends Record {
    constructor(selectedScreenshots) {
        super();
        this.selectedScreenshots = selectedScreenshots;
    }
}

export function Args$reflection() {
    return record_type("Client.Patients.PatientReport.Sections.ScreenshotsSection.Args", [], Args, () => [["selectedScreenshots", list_type(ScreenshotListItemViewModel$reflection())]]);
}

export class DocState extends Record {
    constructor(currentY, fontStack, fontStyleStack, isCentered, heightbuffer, gridMaxColumnCount, gridCurrentColumnCount, gridMaxRowCount, doc) {
        super();
        this.currentY = currentY;
        this.fontStack = fontStack;
        this.fontStyleStack = fontStyleStack;
        this.isCentered = isCentered;
        this.heightbuffer = heightbuffer;
        this.gridMaxColumnCount = (gridMaxColumnCount | 0);
        this.gridCurrentColumnCount = (gridCurrentColumnCount | 0);
        this.gridMaxRowCount = (gridMaxRowCount | 0);
        this.doc = doc;
    }
}

export function DocState$reflection() {
    return record_type("Client.Patients.PatientReport.Sections.ScreenshotsSection.DocState", [], DocState, () => [["currentY", float64_type], ["fontStack", list_type(float64_type)], ["fontStyleStack", list_type(string_type)], ["isCentered", bool_type], ["heightbuffer", float64_type], ["gridMaxColumnCount", int32_type], ["gridCurrentColumnCount", int32_type], ["gridMaxRowCount", int32_type], ["doc", class_type("Client.Bindings.Pdf.JsPdf.JsPdfCore.Jspdf.jsPDF")]]);
}

export class ScreenshotWithData extends Record {
    constructor(screenshot, imageData) {
        super();
        this.screenshot = screenshot;
        this.imageData = imageData;
    }
}

export function ScreenshotWithData$reflection() {
    return record_type("Client.Patients.PatientReport.Sections.ScreenshotsSection.ScreenshotWithData", [], ScreenshotWithData, () => [["screenshot", ScreenshotListItemViewModel$reflection()], ["imageData", class_type("Fable.Core.JS.ArrayBuffer")]]);
}

export class ScreenshotGridItem extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Screenshot", "Placeholder"];
    }
}

export function ScreenshotGridItem$reflection() {
    return union_type("Client.Patients.PatientReport.Sections.ScreenshotsSection.ScreenshotGridItem", [], ScreenshotGridItem, () => [[["Item", ScreenshotWithData$reflection()]], [["index", int32_type]]]);
}

export function Helpers_getS3KeyForScreenshot(s) {
    const matchValue = s.role;
    let pattern_matching_result, _sessionId, s3Key;
    switch (matchValue.tag) {
        case 2: {
            pattern_matching_result = 1;
            _sessionId = matchValue.fields[0];
            s3Key = matchValue.fields[1];
            break;
        }
        case 1: {
            pattern_matching_result = 1;
            _sessionId = matchValue.fields[0];
            s3Key = matchValue.fields[2];
            break;
        }
        default: pattern_matching_result = 0}
    switch (pattern_matching_result) {
        case 0: {
            throw (new Error("Got a parent screenshot in the screenshot PDF section"));
        }
        case 1: {
            return s3Key;
        }
    }
}

export function Helpers_getScreenshots(s3Context, args) {
    return AsyncResultComputationExpression_AsyncResultBuilder__Delay_Z5276B41B(AsyncResultComputationExpression_asyncResult, () => {
        let pr;
        return AsyncResultComputationExpression_AsyncResultBuilder__Bind_454FBA93(AsyncResultComputationExpression_asyncResult, AsyncResult_mapError((arg0_1) => (new ErrorMessage(2, arg0_1)), ofPromise()((pr = map((s) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let tupledArg;
            return ((tupledArg = ["getObject", some(S3_PutObjectRequestParams_get_create()(ofArray([new S3_PutObjectRequestParams(2, s3Context.ActiveBucket), new S3_PutObjectRequestParams(3, Helpers_getS3KeyForScreenshot(s))])))], s3Context.S3Client.getSignedUrlPromise(tupledArg[0], tupledArg[1]))).then((_arg1) => {
                const imageUrl = _arg1;
                return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetch$(imageUrl, empty()).then((_arg2) => (_arg2.arrayBuffer()))))).then((_arg3) => (Promise.resolve(new ScreenshotWithData(new ScreenshotListItemViewModel(s.screenshotId, s.sessionName, s.name, s.date, s.description, s.locationDescription, s.role, s.selected, imageUrl, s.rows, s.columns), _arg3))));
            });
        })), args.selectedScreenshots), Promise.all(pr)))), (_arg4) => AsyncResultComputationExpression_AsyncResultBuilder__Return_1505(AsyncResultComputationExpression_asyncResult, Array_groupBy((s_1) => s_1.screenshot.screenshotId, _arg4, {
            Equals: (x_1, y) => (x_1 === y),
            GetHashCode: stringHash,
        })));
    });
}

export function Helpers_getMaxPageHeight(doc) {
    const pageSize = doc.internal.pageSize;
    return pageSize.getHeight() - Pdf_Spacing_topMargin;
}

export function Helpers_getMaxPageWidth(doc) {
    const pageSize = doc.internal.pageSize;
    return pageSize.getWidth() - (2 * Pdf_Spacing_leftMargin);
}

export function Helpers_getScreenshotIndex(s) {
    const matchValue = s.screenshot.role;
    switch (matchValue.tag) {
        case 2: {
            return 0;
        }
        case 1: {
            return matchValue.fields[1] | 0;
        }
        default: {
            return 0;
        }
    }
}

export function Helpers_getGridItemLocationStringByGridIndex(gridIndex, rows, columns) {
    const matchValue = [gridIndex, rows, columns];
    let pattern_matching_result;
    if (matchValue[0] === 0) {
        if (matchValue[1] === 1) {
            if (matchValue[2] === 1) {
                pattern_matching_result = 0;
            }
            else if (matchValue[2] === 2) {
                pattern_matching_result = 1;
            }
            else if (matchValue[2] === 3) {
                pattern_matching_result = 9;
            }
            else {
                pattern_matching_result = 18;
            }
        }
        else if (matchValue[1] === 2) {
            if (matchValue[2] === 1) {
                pattern_matching_result = 3;
            }
            else if (matchValue[2] === 2) {
                pattern_matching_result = 5;
            }
            else if (matchValue[2] === 3) {
                pattern_matching_result = 12;
            }
            else {
                pattern_matching_result = 18;
            }
        }
        else {
            pattern_matching_result = 18;
        }
    }
    else if (matchValue[0] === 1) {
        if (matchValue[1] === 1) {
            if (matchValue[2] === 2) {
                pattern_matching_result = 2;
            }
            else if (matchValue[2] === 3) {
                pattern_matching_result = 10;
            }
            else {
                pattern_matching_result = 18;
            }
        }
        else if (matchValue[1] === 2) {
            if (matchValue[2] === 1) {
                pattern_matching_result = 4;
            }
            else if (matchValue[2] === 2) {
                pattern_matching_result = 6;
            }
            else if (matchValue[2] === 3) {
                pattern_matching_result = 13;
            }
            else {
                pattern_matching_result = 18;
            }
        }
        else {
            pattern_matching_result = 18;
        }
    }
    else if (matchValue[0] === 2) {
        if (matchValue[1] === 1) {
            if (matchValue[2] === 3) {
                pattern_matching_result = 11;
            }
            else {
                pattern_matching_result = 18;
            }
        }
        else if (matchValue[1] === 2) {
            if (matchValue[2] === 2) {
                pattern_matching_result = 7;
            }
            else if (matchValue[2] === 3) {
                pattern_matching_result = 14;
            }
            else {
                pattern_matching_result = 18;
            }
        }
        else {
            pattern_matching_result = 18;
        }
    }
    else if (matchValue[0] === 3) {
        if (matchValue[1] === 2) {
            if (matchValue[2] === 2) {
                pattern_matching_result = 8;
            }
            else if (matchValue[2] === 3) {
                pattern_matching_result = 15;
            }
            else {
                pattern_matching_result = 18;
            }
        }
        else {
            pattern_matching_result = 18;
        }
    }
    else if (matchValue[0] === 4) {
        if (matchValue[1] === 2) {
            if (matchValue[2] === 3) {
                pattern_matching_result = 16;
            }
            else {
                pattern_matching_result = 18;
            }
        }
        else {
            pattern_matching_result = 18;
        }
    }
    else if (matchValue[0] === 5) {
        if (matchValue[1] === 2) {
            if (matchValue[2] === 3) {
                pattern_matching_result = 17;
            }
            else {
                pattern_matching_result = 18;
            }
        }
        else {
            pattern_matching_result = 18;
        }
    }
    else {
        pattern_matching_result = 18;
    }
    switch (pattern_matching_result) {
        case 0: {
            return "";
        }
        case 1: {
            return "Left:";
        }
        case 2: {
            return "Right:";
        }
        case 3: {
            return "Top:";
        }
        case 4: {
            return "Bottom:";
        }
        case 5: {
            return "Top-Left:";
        }
        case 6: {
            return "Bottom-Left:";
        }
        case 7: {
            return "Top-Right:";
        }
        case 8: {
            return "Bottom-Right:";
        }
        case 9: {
            return "Left:";
        }
        case 10: {
            return "Center:";
        }
        case 11: {
            return "Right:";
        }
        case 12: {
            return "Top-Left:";
        }
        case 13: {
            return "Bottom-Left:";
        }
        case 14: {
            return "Top-Center:";
        }
        case 15: {
            return "Bottom-Center:";
        }
        case 16: {
            return "Top-Right:";
        }
        case 17: {
            return "Bottom-Right:";
        }
        case 18: {
            return "";
        }
    }
}

export function Helpers_fillGridHolesWithPlaceholders(screenshots, rows, columns) {
    return toArray(map((index) => {
        const _arg1 = tryFind((s) => (Helpers_getScreenshotIndex(s) === index), screenshots);
        if (_arg1 == null) {
            return new ScreenshotGridItem(1, index);
        }
        else {
            return new ScreenshotGridItem(0, _arg1);
        }
    }, toList(rangeDouble(0, 1, (rows * columns) - 1))));
}

export function Helpers_getTrueGridSize(screenshots, rows, columns) {
    const getScreenshotIndex = (s) => {
        const matchValue = s.screenshot.role;
        switch (matchValue.tag) {
            case 2: {
                return 0;
            }
            case 1: {
                return matchValue.fields[1] | 0;
            }
            default: {
                return 0;
            }
        }
    };
    const nonEmptyRows = filter((r) => contains(true, map((c) => {
        const index_1 = ((c * rows) + r) | 0;
        return tryFind((_arg1) => {
            if (_arg1.tag === 1) {
                return false;
            }
            else {
                return getScreenshotIndex(_arg1.fields[0]) === index_1;
            }
        }, screenshots) != null;
    }, toList(rangeDouble(0, 1, columns - 1))), {
        Equals: (x, y) => (x === y),
        GetHashCode: structuralHash,
    }), toList(rangeDouble(0, 1, rows - 1)));
    const nonEmptyColumns = filter((c_1) => contains(true, map((r_1) => {
        const index_2 = ((c_1 * rows) + r_1) | 0;
        return tryFind((_arg2) => {
            if (_arg2.tag === 1) {
                return false;
            }
            else {
                return getScreenshotIndex(_arg2.fields[0]) === index_2;
            }
        }, screenshots) != null;
    }, toList(rangeDouble(0, 1, rows - 1))), {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: structuralHash,
    }), toList(rangeDouble(0, 1, columns - 1)));
    return [screenshots.filter((screenshot) => {
        const index_3 = ((screenshot.tag === 1) ? screenshot.fields[0] : getScreenshotIndex(screenshot.fields[0])) | 0;
        const column = (~(~(index_3 / rows))) | 0;
        if (contains(index_3 % rows, nonEmptyRows, {
            Equals: (x_2, y_2) => (x_2 === y_2),
            GetHashCode: numberHash,
        })) {
            return contains(column, nonEmptyColumns, {
                Equals: (x_3, y_3) => (x_3 === y_3),
                GetHashCode: numberHash,
            });
        }
        else {
            return false;
        }
    }), length(nonEmptyRows), length(nonEmptyColumns)];
}

export function Layout_getDoc(docState) {
    return docState.doc;
}

export function Layout_newDocState(doc) {
    return new DocState(Pdf_Spacing_topMargin + Pdf_Spacing_baseSpacingY, empty(), empty(), false, 0, 1, 0, 1, doc);
}

export function Layout_addPage(docState) {
    docState.doc.addPage();
    return new DocState(Pdf_Spacing_topMargin + Pdf_Spacing_baseSpacingY, docState.fontStack, docState.fontStyleStack, docState.isCentered, docState.heightbuffer, docState.gridMaxColumnCount, docState.gridCurrentColumnCount, docState.gridMaxRowCount, docState.doc);
}

export function Layout_getMaxItemWidth(docState) {
    return Helpers_getMaxPageWidth(docState.doc) / docState.gridMaxColumnCount;
}

export function Layout_getMaxItemHeight(docState) {
    return (Helpers_getMaxPageHeight(docState.doc) * 0.8) / docState.gridMaxRowCount;
}

export function Layout_getCurrentX(width, maxItemWidth, docState) {
    if (docState.isCentered) {
        return (Pdf_Spacing_leftMargin + (docState.gridCurrentColumnCount * maxItemWidth)) + ((maxItemWidth - width) / 2);
    }
    else {
        return Pdf_Spacing_leftMargin + (docState.gridCurrentColumnCount * maxItemWidth);
    }
}

export function Layout_checkHeight(expectedHeight, docState) {
    const newDocState = ((docState.currentY + expectedHeight) >= Helpers_getMaxPageHeight(docState.doc)) ? Layout_addPage(docState) : docState;
    return new DocState(newDocState.currentY, newDocState.fontStack, newDocState.fontStyleStack, newDocState.isCentered, Math.max(newDocState.heightbuffer, expectedHeight), newDocState.gridMaxColumnCount, newDocState.gridCurrentColumnCount, newDocState.gridMaxRowCount, newDocState.doc);
}

export function Layout_applyHeight(docState) {
    const columnCount = (docState.gridCurrentColumnCount + 1) | 0;
    if (columnCount >= docState.gridMaxColumnCount) {
        return new DocState(docState.currentY + docState.heightbuffer, docState.fontStack, docState.fontStyleStack, docState.isCentered, 0, docState.gridMaxColumnCount, 0, docState.gridMaxRowCount, docState.doc);
    }
    else {
        return new DocState(docState.currentY, docState.fontStack, docState.fontStyleStack, docState.isCentered, docState.heightbuffer, docState.gridMaxColumnCount, columnCount, docState.gridMaxRowCount, docState.doc);
    }
}

export function Layout_fontSizePush(fontSize, docState) {
    const previousFont = docState.doc.getFontSize();
    docState.doc.setFontSize(fontSize);
    return new DocState(docState.currentY, cons(previousFont, docState.fontStack), docState.fontStyleStack, docState.isCentered, docState.heightbuffer, docState.gridMaxColumnCount, docState.gridCurrentColumnCount, docState.gridMaxRowCount, docState.doc);
}

export function Layout_fontSizePop(docState) {
    const matchValue = docState.fontStack;
    if (!isEmpty(matchValue)) {
        docState.doc.setFontSize(head(matchValue));
        return new DocState(docState.currentY, tail(matchValue), docState.fontStyleStack, docState.isCentered, docState.heightbuffer, docState.gridMaxColumnCount, docState.gridCurrentColumnCount, docState.gridMaxRowCount, docState.doc);
    }
    else {
        return docState;
    }
}

export function Layout_fontStylePush(fontStyle, docState) {
    const previousFont = docState.doc.getFont();
    const previousFontStyle = previousFont.fontStyle;
    docState.doc.setFont("times", fontStyle);
    return new DocState(docState.currentY, docState.fontStack, cons(previousFontStyle, docState.fontStyleStack), docState.isCentered, docState.heightbuffer, docState.gridMaxColumnCount, docState.gridCurrentColumnCount, docState.gridMaxRowCount, docState.doc);
}

export function Layout_fontStylePop(docState) {
    const matchValue = docState.fontStyleStack;
    if (!isEmpty(matchValue)) {
        docState.doc.setFont("times", head(matchValue));
        return new DocState(docState.currentY, docState.fontStack, tail(matchValue), docState.isCentered, docState.heightbuffer, docState.gridMaxColumnCount, docState.gridCurrentColumnCount, docState.gridMaxRowCount, docState.doc);
    }
    else {
        return docState;
    }
}

export function Layout_setCentered(centered, docState) {
    return new DocState(docState.currentY, docState.fontStack, docState.fontStyleStack, centered, docState.heightbuffer, docState.gridMaxColumnCount, docState.gridCurrentColumnCount, docState.gridMaxRowCount, docState.doc);
}

export function Layout_addText(text, docState) {
    const maxX = Layout_getMaxItemWidth(docState);
    return fold((docState_1, t) => {
        let ds;
        const lineHeight = Pdf_Images_Basic_ptToMm(docState_1.doc.getLineHeight());
        const currentX = Layout_getCurrentX(docState_1.doc.getTextWidth(t), maxX, docState_1);
        return Layout_applyHeight((ds = Layout_checkHeight(lineHeight, docState_1), (void ds.doc.text(t, currentX, ds.currentY), ds)));
    }, docState, docState.doc.splitTextToSize(text, maxX));
}

export function Layout_addSpace(height, docState) {
    return Layout_applyHeight(Layout_checkHeight(height, docState));
}

export function Layout_addImage(image, docState) {
    let ds;
    const imageData = new Uint8Array(image.imageData);
    const imageProperties = docState.doc.getImageProperties(imageData);
    const mmWidth = imageProperties.width;
    const mmHeight = imageProperties.height;
    const maxItemWidth = Layout_getMaxItemWidth(docState);
    const maxItemHeight = Layout_getMaxItemHeight(docState);
    const maxWidth = Math.min(mmWidth, maxItemWidth);
    const maxHeight = Math.min(mmHeight, maxItemHeight);
    const imageRatio = mmWidth / mmHeight;
    const patternInput = ((maxWidth / maxHeight) < imageRatio) ? [maxWidth, maxWidth * (1 / imageRatio)] : [maxHeight * imageRatio, maxHeight];
    const width = patternInput[0];
    const height = patternInput[1];
    const currentX = Layout_getCurrentX(width, maxItemWidth, docState);
    return Layout_applyHeight((ds = Layout_checkHeight(height + Pdf_Images_Basic_ptToMm(docState.doc.getLineHeight()), docState), (void ds.doc.addImage({
        compression: "NONE",
        height: height,
        imageData: imageData,
        width: width,
        x: currentX,
        y: ds.currentY,
    }), ds)));
}

export function Layout_setGridColumns(columns, docState) {
    return new DocState(docState.currentY, docState.fontStack, docState.fontStyleStack, docState.isCentered, docState.heightbuffer, columns, docState.gridCurrentColumnCount, docState.gridMaxRowCount, docState.doc);
}

export function Layout_setGridRows(rows, docState) {
    return new DocState(docState.currentY, docState.fontStack, docState.fontStyleStack, docState.isCentered, docState.heightbuffer, docState.gridMaxColumnCount, docState.gridCurrentColumnCount, rows, docState.doc);
}

export const Components_addSectionTitle = (arg_1) => Layout_fontSizePop(Layout_addText("Captured Images", Layout_fontSizePush(20, arg_1)));

export function Components_addScreenshotTitle(image) {
    return (arg_3) => Layout_fontSizePop(Layout_fontStylePop(Layout_addText(image.screenshot.name, Layout_fontStylePush("bold", Layout_fontSizePush(12, arg_3)))));
}

export function Components_addScreenshotGridLocation(gridIndex, rows, columns) {
    let f1_3;
    let f1_2;
    let f2_1;
    const text = Helpers_getGridItemLocationStringByGridIndex(gridIndex, rows, columns);
    f2_1 = ((docState_2) => Layout_addText(text, docState_2));
    f1_2 = ((arg_1) => f2_1(Layout_fontStylePush("bold", Layout_fontSizePush(10, arg_1))));
    f1_3 = ((arg_2) => Layout_fontStylePop(f1_2(arg_2)));
    return (arg_3) => Layout_fontSizePop(f1_3(arg_3));
}

export function Components_addScreenshotCaption(image) {
    let f1_4;
    let f1_3;
    let f1_2;
    let f2_1;
    const text = `${image.screenshot.sessionName} | ${image.screenshot.locationDescription}`;
    f2_1 = ((docState_2) => Layout_addText(text, docState_2));
    f1_2 = ((arg_1) => f2_1(Layout_fontStylePush("italic", Layout_fontSizePush(10, arg_1))));
    f1_3 = ((arg_2) => Layout_fontStylePop(f1_2(arg_2)));
    f1_4 = ((arg_3) => Layout_fontSizePop(f1_3(arg_3)));
    return (arg_4) => Layout_addSpace(5, f1_4(arg_4));
}

export function Components_addScreenshotDescription(image) {
    return (arg_2) => Layout_addSpace(5, Layout_fontSizePop(Layout_addText(image.screenshot.description, Layout_fontSizePush(12, arg_2))));
}

export function Components_addScreenshotImage(image) {
    return (arg_1) => Layout_setCentered(false, Layout_addImage(image, Layout_setCentered(true, arg_1)));
}

export function Components_addMissingScreenshotNote(image) {
    return (arg_6) => Layout_addSpace(5, Layout_fontSizePop(Layout_fontStylePop(Layout_setCentered(false, Layout_addText("Missing image - could not find screenshot on server", Layout_setCentered(true, Layout_fontStylePush("italic", Layout_fontSizePush(10, arg_6))))))));
}

export const Components_addScreenshotPlaceholder = (docState) => Layout_addText("", docState);

export function Components_startGrid(rows, columns) {
    return (arg) => Layout_setGridRows(rows, Layout_setGridColumns(columns, arg));
}

export const Components_endGrid = (arg) => Layout_setGridRows(1, Layout_setGridColumns(1, arg));

export function create(doc, s3context, args) {
    return AsyncResultComputationExpression_AsyncResultBuilder__Delay_Z5276B41B(AsyncResultComputationExpression_asyncResult, () => AsyncResultComputationExpression_AsyncResultBuilder__Bind_454FBA93(AsyncResultComputationExpression_asyncResult, Helpers_getScreenshots(s3context, args), (_arg1) => {
        const screenshotsWithImagePath = _arg1;
        return AsyncResultComputationExpression_AsyncResultBuilder__Return_1505(AsyncResultComputationExpression_asyncResult, (screenshotsWithImagePath.length > 0) ? Layout_getDoc(fold(uncurry(2, (tupledArg) => {
            const docState_1 = tupledArg[0];
            const index = tupledArg[1] | 0;
            return (tupledArg_1) => {
                const images = tupledArg_1[1];
                if (images.length === 0) {
                    return [docState_1, index];
                }
                else {
                    const titleState = Components_addScreenshotTitle(images[0])(docState_1);
                    const patternInput = defaultArg(map_1((i) => [i.screenshot.rows, i.screenshot.columns], tryHead(images)), [1, 1]);
                    const rawRows = patternInput[0] | 0;
                    const patternInput_1 = Helpers_getTrueGridSize(Helpers_fillGridHolesWithPlaceholders(images, images[0].screenshot.rows, images[0].screenshot.columns), rawRows, patternInput[1]);
                    const rows = patternInput_1[1] | 0;
                    const columns = patternInput_1[2] | 0;
                    const patternInput_2 = fold(uncurry(2, (tupledArg_2) => {
                        const count = tupledArg_2[1] | 0;
                        return (image_2) => [Components_addScreenshotDescription(image_2)(Components_addScreenshotCaption(image_2)(Components_addScreenshotGridLocation(count, rows, columns)(tupledArg_2[0]))), count + 1];
                    }), [Components_endGrid(fold((docState_2, image_1) => {
                        if (image_1.tag === 1) {
                            return Components_addScreenshotPlaceholder(docState_2);
                        }
                        else {
                            const screenshot = image_1.fields[0];
                            if (screenshot.imageData.byteLength >= 1000) {
                                return Components_addScreenshotImage(screenshot)(docState_2);
                            }
                            else {
                                return Components_addMissingScreenshotNote(screenshot)(docState_2);
                            }
                        }
                    }, Components_startGrid(rows, columns)(titleState), sortBy((image) => {
                        const index_2 = ((image.tag === 1) ? image.fields[0] : Helpers_getScreenshotIndex(image.fields[0])) | 0;
                        return (index_2 + ((index_2 % rawRows) * images.length)) | 0;
                    }, patternInput_1[0], {
                        Compare: comparePrimitives,
                    }))), 0], images);
                    return [((index < (screenshotsWithImagePath.length - 1)) ? (Layout_addPage) : ((x_1) => x_1))(patternInput_2[0]), index + 1];
                }
            };
        }), [Components_addSectionTitle(Layout_newDocState(doc)), 0], screenshotsWithImagePath)[0]) : doc);
    }));
}

